export default [
    {
        name: 'subfamily',
        props: {
            label: 'Subfamilia',
        },
        flex: {
            sm6: true,
            lg6: true,
        },
        type: 'text-field',
    },
]
